/**
 * SEO component that queries for data with
 * Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/
 */

import * as React from "react"
import { useStaticQuery, graphql, Script } from "gatsby"

import { appleAppStoreId } from "../../constants"


interface OwnProps {
  canonicalUrl?: string
  lang?: string
  jsonLD?: string
  ogDescription?: string
  ogImage?: string
  ogTitle?: string
  ogType?: string
  title?: string
}

export function Seo({ 
  canonicalUrl,
  jsonLD,
  ogDescription = "",
  ogImage = "",
  ogTitle,
  ogType,
  title,
}) {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  )
  const siteMetadata = site.siteMetadata
  const metaDescription = ogDescription || siteMetadata.description
  const baseImageUrl = ogImage?.split("?")[0]
  const defaultOGImage =
    "https://images.prismic.io/join-parachute/ZgXq3ct2UUcvBQ-f_homepage-og.png"
  const pageTitle = ogTitle || title
  const defaultTitle = pageTitle ? ` | ${siteMetadata.title}` : ""
  const canonical = canonicalUrl

  return (
    <>
      <html lang="en-US" />
      <title>
        {pageTitle}
        {defaultTitle}
      </title>
      {appleAppStoreId && (
        <meta name="apple-itunes-app" content={`app-id=${appleAppStoreId}`} />
      )}
      {metaDescription && <meta name="description" content={metaDescription} />}
      {ogDescription ||
        (metaDescription && (
          <meta
            name="og:description"
            content={ogDescription || metaDescription}
          />
        ))}
      <meta name="og:image" content={baseImageUrl || defaultOGImage} />
      <meta name="og:title" content={pageTitle || "Join Parachute"} />
      <meta name="og:type" content={ogType || "page"} />
      <meta name="twitter:card" content="summary" />
      {siteMetadata?.author && (
        <meta name="twitter:creator" content={siteMetadata.author} />
      )}
      {metaDescription && (
        <meta name="twitter:description" content={metaDescription} />
      )}
      <meta name="twitter:image" content={baseImageUrl || defaultOGImage} />
      <meta name="twitter:title" content={pageTitle || "Join Parachute"} />
      <meta
        name="google-site-verification"
        content="EraMpmlqTYwoat9dSFRRnEkpbZhl0MqPScX2N1yL_bM"
      />
      <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Martel+Sans:wght@400;600;800&family=Poppins:ital,wght@0,400;0,600;0,800;1,400;1,600;1,800&display=swap" />
      <noscript>{`
        <link
          href="https://fonts.googleapis.com/css2?family=Martel+Sans:wght@400;600;800&family=Poppins:ital,wght@0,400;0,600;0,800;1,400;1,600;1,800&display=swap"
          rel="stylesheet"
          type="text/css"
        />
      `}</noscript>
      <link href={canonical} rel="canonical" />
      <Script
        src="/scripts/onelink-smart-script.js"
      />
      <Script
        src="/scripts/hot-jar-tracking.js"
      />
      <Script type="text/javascript" src="/scripts/snap-pixel.js" />
      <Script
        src="/scripts/analytics-middleware.js"
        branch={process.env.BRANCH}
      />
      {jsonLD && (
        <Script type="application/ld+json">{`
        ${jsonLD}
      `}</Script>
      )}
    </>
  )
}
